import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-icon",
  "use": "arrow-icon-usage",
  "viewBox": "0 0 14 13",
  "content": "<symbol viewBox=\"0 0 14 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-icon\">\n\t<path d=\"M10.1433 5.64833L5.67333 1.17833L6.85167 0L13.3333 6.48167L6.85167 12.9633L5.67333 11.785L10.1433 7.315H0V5.64833H10.1433Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol